module.exports = __webpack_public_path__ + "img/datadog.8774a742.png";